import styled from 'styled-components';
import C from '@assets/themes/colors';
interface IRootProps {
  selected?:boolean;
  height?: number;
  width?: number;
  padding?: string;
  position?: string;
  top?:string
}

export const Root = styled.div`
  width: auto;
`;

export const Menu = styled.div`
  width: 289px;
  height: fit-content;
  display: none;
  position: absolute;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 80;
  right: ${(props: IRootProps) => props.position==='right' ? '47px' : ''};
  margin-top: ${(props: IRootProps) => props.top? props.top : '9px'};
  margin-left: ${(props: IRootProps) => props.position==='right' ? '' : '-75px'};
`;

export const Title = styled.div`
  height: 19px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  padding: ${(props: IRootProps) => props.padding ? props.padding:'26px 29px 14px 29px'};
`;

export const OptionsContainer = styled.div`
  height: auto;
  max-height: 377px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 12px;
`;


export const Option = styled.div`
  width: auto;
  flex-grow: 0;
  background-color: ${(props: IRootProps) => props.selected ? 'rgba(18, 36, 66, 0.05)':'#ffffff'};
  padding: 11px 29px;
  font-size: 19px;
  font-weight: normal;
  color: ${C.DARK_GRAY};
  cursor:pointer;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;


export const Format = styled.div`
  width: auto;
  border-radius: 5px;
  padding: 7px 9px;;
  flex-grow: 0;
  background-color: ${(props: IRootProps) => props.selected? 'rgba(18, 36, 66, 0.05)':'#ffffff'};
  margin: 11px 20px;
  font-size: 16px;
  font-weight: normal;
  color: ${C.DARK_GRAY};
  cursor:pointer;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Size = styled.div`
  width: ${(props: IRootProps) => props.width ? `${props.width}px` : 'auto'};
  height: ${(props: IRootProps) => props.height ? `${props.height}px` : 'auto'};
  min-height: 32px;
  min-width: 75px;
  border-radius: 5px;
  border: solid 1px ${C.BLUE};
  margin: 2px;
  font-size: 12px;
  font-weight: normal;
  color: ${C.DARK_GRAY};
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
`;

export const Back = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  color: ${C.DARK_BLUE};
  display: flex;
  align-items: center;
  padding: 30px 0px 0px 20px;
  cursor: pointer;
`;

export const FormContainer = styled.div`
  margin: 37px 22px;
  margin-bottom: 24.5px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  text-align: left;
  color: ${C.BLUE};
  margin-top: 12.5px;
  display: block;
`;